if (!customElements.get('quick-shop')) {
  class Quickshop extends HTMLElement {
    constructor() {
      super();

      this.parentCard = this.closest('[data-product-card]');
      this.popup = this.parentCard.querySelector('[data-quickshop-popup]');

      // Bind popup toggle events
      this.parentCard.querySelectorAll('[data-quickshop-toggle]').forEach((button) =>
        button.addEventListener('click', this.onPopupToggle.bind(this))
      );

      // Bind option select events
      this.querySelectorAll('[data-quickshop-option]').forEach((option) =>
        option.addEventListener('click', this.onOptionSelect.bind(this, option.value))
      );
    }

    /**
     * Toggles the options popup
     * @description Renders the products based on the fetch url data.
     */
    onPopupToggle() {
      this.popup.classList.toggle('quickshop__popup--is-open');
      document.body.classList.toggle('quickshop-popup-is-open');
    }

    /**
     * Adds a variant to the cart
     * @description Adds the clicked option/variant to the cart leveraging the product form component.
     * @param {String} variantId
     */
    onOptionSelect(variantId) {
      const productForm = this.querySelector('product-form');
      const hiddenCartBtn = productForm.querySelector('input[name="id"]');
      const submitButton = productForm.querySelector('[type="submit"]');

      this.popup.classList.remove('quickshop__popup--is-open');
      document.body.classList.remove('quickshop-popup-is-open');

      hiddenCartBtn.value = variantId;
      submitButton.click();

    }
  }

  window.Quickshop = Quickshop;
  customElements.define('quick-shop', Quickshop);
}
